import ResetPassForm from "../../components/ResetPassForm" 

export default function NewPass() {
  return (
    <div>
      <ResetPassForm />
    </div>
  );
}
